import React from 'react'
import CatalogItemBaseList, {
  CatalogItemBaseListProps,
} from 'ui-shared/WrappedInputs/CatalogItemBaseList'

const LocationSectionList: React.FC<CatalogItemBaseListProps> = (props) => (
  <CatalogItemBaseList {...props} />
)

export default LocationSectionList
